import React, { useState } from "react";
import { Outlet } from "react-router";
import { useRecoilValue } from "recoil";
import { authState } from "../../../recoil/auth";
import ErrorPage from "../ErrorPage";
import AdminHome from "./AdminHome";
import AdminExamRoom from "./AdminExamRoom";
// import "../../../publish/css/admin.css";

const AdminRouter = () => {
  const auth = useRecoilValue(authState);
  const [isPageStep, setPageStep] = useState(0);

  const [searchTestRoom, setSearchTestRoom] = useState("");

  switch (isPageStep) {
    case 0:
      return (
        <AdminHome
          isPageStep={isPageStep}
          setPageStep={setPageStep}
          setSearchTestRoom={setSearchTestRoom}
        />
      );
    case 1:
      return (
        <AdminExamRoom
          isPageStep={isPageStep}
          setPageStep={setPageStep}
          searchTestRoom={searchTestRoom}
        />
      );
    default:
      return <ErrorPage />;
  }
  // if (auth)
  //   return (
  //     <>
  //       <link rel="stylesheet" type="text/css" href="/css/admin.css" />
  //       <Outlet />
  //     </>
  //   );
  // else return <Redirect to="./login" />
};

export default AdminRouter;
